export const Type = {
    Journalist: 1,
    Partner: 2
}

Object.freeze(Type)

export default class SearchContext {
    constructor(options = {}) {
        this.filter = options.filter;
        this.search = options.search;
        this.search_options = options.search_options;
        this.type = options.type;
    }

    setType(status) {
        if (status === true) {
            this.type = Type.Partner;
            return;
        }
        this.type = Type.Journalist;
    }
}
